import {
  UpdateRequest,
  ListRequest,
  RequestServiceClient,
  ListRequestAuditRequest,
  CreateRequest,
  ReadMaximumWithdrawableRequest,
  ReadSummaryRequest,
  EmptyRequest,
  GetNewRequestIdRequest,
  GetFeeRequest,
} from '../proto/bankpb/request_grpc_web_pb';
import { stringToProtoDate } from './ConvertService';
import { auth } from '../lib/auth/Auth';
import authSvc from './AuthService';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new RequestServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

const userId = authSvc.getCurrentUser()?.UserId;

export async function create(param) {
  return new Promise((resolve, reject) => {
    const req = new CreateRequest();
    req.setCorrespondent(param.correspondent);
    req.setAccountNo(param.accountNo);
    req.setBankId(param.bankId);
    req.setTransferType(param.transferType);
    req.setAmt(param.amt);
    req.setFee(param.fee);
    req.setFedNo(param.fedNo);
    req.setExternalId(param.externalId);
    req.setBank(param.bank);
    req.setBankNote(param.bankNote);
    req.setInternalNote(param.internalNote);
    req.setStatus(param.status);
    req.setRequestType(param.requestType);
    req.setWalletId(param.walletId);
    req.setRequestId(param.requestId);

    service.create(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function update(param) {
  return new Promise((resolve, reject) => {
    const req = new UpdateRequest();
    req.setRequestId(param.requestId);
    req.setStatus(param.status);
    req.setFedNo(param.fedNo);
    req.setInternalNote(param.internalNote);
    req.setAmt(param.amt);
    req.setFee(param.fee);

    // req.setSendTo(param.sendTo);

    req.setExternalId(param.externalId);

    service.update(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readCashBalance() {
  return new Promise((resolve, reject) => {
    const req = new EmptyRequest();

    service.readCashBalance(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function list(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListRequest();
    req.setFromDate(stringToProtoDate(param.fromDate));
    req.setToDate(stringToProtoDate(param.toDate));
    req.setCorrespondent(param.correspondent);
    req.setAccountNo(param.accountNo);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setTransferType(param.transferType);
    req.setStatus(param.status);
    req.setRequestType(param.requestType);
    req.setExternalId(param.externalId);
    req.setRequestId(param.requestId);
    req.setSign(param.sign);
    req.setAmount(param.amount);
    req.setIsOpen(param.isOpen);
    req.setDateType(param.dateType);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.list(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listRequestAudit(id) {
  return new Promise((resolve, reject) => {
    const req = new ListRequestAuditRequest();
    req.setRequestId(id);

    service.listRequestAudit(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readMaximumWithdrawable(correspondent, accountNo) {
  return new Promise((resolve, reject) => {
    const req = new ReadMaximumWithdrawableRequest();
    req.setCorrespondent(correspondent);
    req.setAccountNo(accountNo);

    service.readMaximumWithdrawable(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readSummary() {
  return new Promise((resolve, reject) => {
    const req = new ReadSummaryRequest();
    req.setUsrId(userId);

    service.readSummary(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getNewRequestId() {
  return new Promise((resolve, reject) => {
    let req = new GetNewRequestIdRequest();

    service.getNewRequestId(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getFee(param) {
  return new Promise((resolve, reject) => {
    const req = new GetFeeRequest();
    req.setCorrespondent(param.correspondent);
    req.setAccountNo(param.accountNo);
    req.setAmt(param.amt === '' ? '0' : param.amt);
    req.setRequestType(param.requestType);
    req.setTransferType(param.transferType);
    req.setIsInternational(param.isInternational);
    req.setBroker(param.broker);

    service.getFee(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
